<template>
<div class="index_footer">
    <div class="fot">
        <div class="container">
            <div class="wrap">
                <div class="contact">{{getIndexData.fixedFieldMap['links']}}</div>
                <div class="authior">
                    <i class="iconfont icon-banquan-copy" />
                    <span class="statement">{{getIndexData.fixedFieldMap['copyright']}}</span>
                    <a href="http://beian.miit.gov.cn" rel="noopener" target="_blank">粤ICP备19127719号-1</a>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
 import {mapGetters} from 'vuex'
export default {
    computed: {
      ...mapGetters(['getIndexData']),
    }
}
</script>

<style scoped lang='stylus'>
@import "~styl/mixin.styl"
.index_footer
    mt(30)
    fs(0)
    .fot
        h(150)
        bg(rgb(82,69,93))
        .container
            container()
            hh()
            lh(150)
            ta(center)
            .wrap
                d(inline-block)
                vertical-align middle
                c(#fff)
                .contact
                    pb(20)
                    fs(13)
                    line-height normal
                .authior
                    line-height normal
                    .statement
                        fs(13)
                        vertical-align middle
                    i
                        fs(18)
                        c(#fff)
                        vertical-align middle
                    a
                        vertical-align middle
                        fs(14)
                        c(#fff)
                        pl(20)


</style>



// WEBPACK FOOTER //
// src/components/index/index_footer.vue